/*
 * @author: wayou
 * @date: 2018-09-10 18:06:35
 * @description: 滑杆组件
 * http://jsbin.com/dulifezi/2/edit?js,output
 * https://stackoverflow.com/a/22762683/1553656
 *
 */

import React, { Component } from 'react';
import { DRAGGABLE_TYPE } from '@umu/umu-types';

import './rangeSlider.scss';

interface IRangeSliderProps {
    /**
     * 当前位置，0~1之间的数值
     */
    percentage: number;

    /**
     * 音视频中 buffer 数据,1~1 之间的数值
     */
    buffered?: number;

    /**
     * 是否禁用拖拽
     */
    disable?: boolean;

    /**
     * 进度条拖动类型
     */
    draggableType?: DRAGGABLE_TYPE;

    /**
     * 可拖动的最大值
     */
    dragLimit?: number;

    onDrag?: (percentage: number) => void;
}

export default class RangeSlider extends Component<IRangeSliderProps, {}> {
    public static defaultProps: Partial<IRangeSliderProps> = {
        percentage: 0,
        buffered: 0,
        disable: false,
    };

    private isMouseDown: boolean = false;
    private slider?: HTMLElement;

    constructor(props: IRangeSliderProps) {
        super(props);
        this.state = {
            percentage: props.percentage,
        };
    }

    public componentDidMount() {
        this.initialEvents();
    }

    public componentWillUnmount() {
        document.removeEventListener('mousemove', this.draggerMouseMove);
        document.removeEventListener('touchstart', this.draggerTouchMove);
        document.removeEventListener('mouseup', this.draggerMouseUp);
        document.removeEventListener('touchend', this.draggerMouseUp);
    }

    public render() {
        const { disable, percentage, buffered } = this.props;
        const processedStyle = Object.assign(
            {
                width: this.getProcessedWidth(percentage),
            },
            disable
                ? {
                      minWidth: 'auto',
                  }
                : {},
        );
        const draggerStyle = this.getDraggerStyle(percentage);
        return (
            <div
                className="range-slider"
                onMouseDown={this.sliderMouseMove}
                onTouchMove={this.sliderTouchMove}
                ref={(ref) => {
                    this.slider = ref as HTMLElement;
                }}
            >
                <div className="range-slider-bar range-slider-buffered" style={{ width: `${buffered! * 100}%` }} />
                <div className="range-slider-bar range-slider-processed" style={processedStyle}>
                    {disable ? null : <span className="range-slider-dragger" style={draggerStyle} />}
                </div>
            </div>
        );
    }

    private getProcessedWidth(percentage: number): string {
        return `${percentage * 100}%`;
    }

    private getDraggerStyle(percentage: number) {
        // 最左边时圆点会超出，这里修正一下
        if (percentage < 0.1) {
            return {
                // left: 0,
            };
        }
        return {};
    }

    private initialEvents = () => {
        document.addEventListener('mousemove', this.draggerMouseMove);
        document.addEventListener('touchmove', this.draggerTouchMove);
        document.addEventListener('mouseup', this.draggerMouseUp);
        document.addEventListener('touchend', this.draggerMouseUp);
    };

    private draggerMouseUp = () => {
        this.isMouseDown = false;
    };

    private sliderMouseMove = (event: React.MouseEvent<HTMLElement>) => {
        if (this.props.disable) {
            return;
        }
        this.isMouseDown = true;
        this.updateDragger(event.pageX);
        return false;
    };

    private sliderTouchMove = (event: React.TouchEvent<HTMLElement> | TouchEvent) => {
        if (this.props.disable) {
            return;
        }
        this.isMouseDown = true;
        if (event.touches && event.touches[0]) {
            this.updateDragger(event.touches[0].pageX);
        }
        return false;
    };

    private draggerMouseMove = (event: React.MouseEvent<HTMLElement> | MouseEvent) => {
        this.updateDragger(event.pageX);
    };

    private draggerTouchMove = (event: React.TouchEvent<HTMLElement> | TouchEvent) => {
        if (event.touches && event.touches[0]) {
            this.updateDragger(event.touches[0].pageX);
        }
    };

    private updateDragger = (pageX: number) => {
        if (!this.isMouseDown) {
            return;
        }
        const percentage = this.calculatePercentage(pageX);

        if (this.props.onDrag) {
            this.props.onDrag(percentage);
        }
    };

    private calculatePercentage = (pageX: number): number => {
        let percentage = this.props.percentage;
        if (this.slider) {
            percentage = (pageX - this.slider.getBoundingClientRect().left) / this.slider.offsetWidth;
        }
        if (percentage < 0) {
            percentage = 0;
        }
        if (percentage > 1) {
            percentage = 1;
        }
        return percentage;
    };
}
